import { createQueryKeys } from '../../factories';

export const GLOSSARY_NAMESPACE = ['glossary'];

export const glossaryQueryKeyFactory = createQueryKeys(GLOSSARY_NAMESPACE);
